import React from 'react';
import _ from 'lodash';
import { listOfNames, showNames } from '../../helpers/strings';
import FacebookCounterReaction from './FacebookCounterReaction';

interface Counter {
  emoji: string;
  by: string;
}

interface FacebookCounterProps {
  id: string;
  counters: Counter[];
  user: string;
  important?: string[];
  onclick?: () => void;
  bg?: string;
  recalculateposition?: () => void;
  place?: string;
  includeLabel?: boolean;
}

export const FacebookCounter: React.FC<FacebookCounterProps> = ({
  id,
  counters,
  user,
  important = [],
  onclick,
  bg = '#fff',
  recalculateposition,
  place,
  includeLabel = false,
}) =>
{
  const isDark = document.documentElement.classList.contains('dark');
  const resolvedBg = isDark ? '#333535' : bg;
  const styles = {
    counter: {
      display: 'flex',
      cursor: 'pointer',
      color: isDark ? '#a9a093' : 'rgb(135, 166, 196)',
      fontFamily: `"Roboto", Arial, sans-serif`,
      fontSize: '10px',
      fontWeight: '500',
      float: 'right' as const,
    },
    name: {
      paddingLeft: '4px',
      marginTop: '2px',
      zIndex: 1,
    },
  };

  const groups = _.groupBy(counters, 'emoji');
  const names = _.map(counters, 'by');

  const nameString: string[] = [];

  if (includeLabel)
  {
    if (_.includes(names, user))
    {
      nameString.push('You');
    }
    else if (names.length > 0)
    {
      const firstUserArray = names[0]!.split(' ');
      const firstUserName =
        firstUserArray.length >= 2 ? `${firstUserArray[0]} ${firstUserArray[1]}` : names[0]!;

      nameString.push(firstUserName);
    }

    if (important.length)
    {
      if (important[0] && _.includes(names, important[0]))
      {
        nameString.push(important[0]!);
      }
      if (important[1] && _.includes(names, important[1]))
      {
        nameString.push(important[1]!);
      }
    }

    const othersCount = names.length - nameString.length;
    if (othersCount > 0)
    {
      nameString.push(`${othersCount} other${othersCount === 1 ? '' : 's'}`);
    }
  }
  else
  {
    nameString.push(`${names.length}`);
  }

  const returnUsers = (counters: Counter[], reaction: string): Counter[] =>
  {
    return counters.filter(x => x.emoji === reaction);
  };

  return (
    <div style={styles.counter} onClick={onclick}>
      {_.map(_.keys(groups), (reaction, i, reactions) => (
        <FacebookCounterReaction
          key={reaction}
          reaction={reaction}
          index={reactions.length - i}
          bg={resolvedBg}
          users={returnUsers(counters, reaction)}
          recalculatePosition={recalculateposition}
          place={place as any}
          idCounter={`${id}_${reaction}_${i}`}
        />
      ))}
      <div onClick={showNames} style={styles.name}>
        {listOfNames(nameString)}
      </div>
    </div>
  );
};

export default FacebookCounter;
